import axios from "axios";
import { ResponseAPIWithPagination } from "../../../common/types/API.types";
import { LinkPlan, LinkPlanPatch } from "../types/link.types";

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL+'/api/v1';

export const getAllLinkFromPlan = async (currentPage: number, pageSize: number, planId : string) => {
    const params =  "currentPage=" + currentPage + "&pageSize=" + pageSize;
    return (await axios.get<ResponseAPIWithPagination<LinkPlan>>(`${BACKEND_URL}/planbt/${planId}/links?${params}`)).data;
}

export const createLinkPlan = async (link: LinkPlanPatch, planId: string) => {
    return (await axios.post<LinkPlan>(`${BACKEND_URL}/planbt/${planId}/links`, link)).data;
}

export const updateLinkPlan = async (linkId: string, link: LinkPlanPatch, planId: string) => {
    return (await axios.put<LinkPlan>(`${BACKEND_URL}/planbt/${planId}/links/${linkId}`, link)).data;
}

export const deleteLinkPlan = async (linkId: string, planId: string) => {
    return (await axios.delete<unknown>(`${BACKEND_URL}/planbt/${planId}/links/${linkId}`)).data;
}

export const getSingleLink = async (linkId: string, planId: string) => {
    return (await axios.get<LinkPlan>(`${BACKEND_URL}/planbt/${planId}/links/${linkId}`)).data;
}

export const linkAPI = {
    getAllLinkFromPlan,
    createLinkPlan,
    updateLinkPlan,
    deleteLinkPlan,
    getSingleLink
    
}